// extracted by mini-css-extract-plugin
module.exports = {"container":"PriceImage_container__theQv","image":"PriceImage_image__uD5vZ","overlay":"PriceImage_overlay__OZlTI","shimmer":"PriceImage_shimmer__EPjCb"};